import React from "react";
import { numberWithCommas } from "./orderUtils";

function FeeRow({ label, amount, className = "d-flex mt-1" }) {
  return (
    <div className={className}>
      <h5 className="mr-2">{label}</h5>
      <h5 className="font-weight-bold">
        ₦{amount && numberWithCommas(amount)}
      </h5>
    </div>
  );
}

export default function OrderSummary({ singleOrder }) {
  const couponAmount = singleOrder?.order_coupons?.[0]?.amount;

  return (
    <div className="float-right text-right mt-4">
      <FeeRow
        label="Delivery fee:"
        amount={singleOrder?.order_delivery_fee}
        className="d-flex"
      />
      <FeeRow label="Discount:" amount={singleOrder?.order_discount} />
      <FeeRow
        label="Insurance fee:"
        amount={singleOrder?.order_insurance_fee}
      />
      <FeeRow label="Service fee:" amount={singleOrder?.order_service_fee} />
      <FeeRow label="Tax fee:" amount={singleOrder?.order_tax_fee} />
      {singleOrder?.order_coupons?.length > 0 && (
        <FeeRow label="Coupon:" amount={couponAmount} />
      )}
      <hr className="my-2" />
      <h5>Total amount:</h5>
      <h3>
        ₦
        {singleOrder?.order_amount &&
          numberWithCommas(singleOrder.order_amount)}
        {singleOrder?.second_party_order && (
          <>
            <br></br>
            <small className="is-invalid small">Order value not summed</small>
          </>
        )}
      </h3>
    </div>
  );
}
